var _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSurvey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 115,
    viewBox: "0 0 171 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M171 0H0V115H171V0Z",
    fill: "#485bff",
    fillOpacity: 0.15
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 66,
    width: 86,
    height: 36,
    rx: 6.54545,
    fill: "#485bff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 74,
    width: 51.7795,
    height: 3.83851,
    rx: 1.91925,
    fill: "white",
    fillOpacity: 0.7
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 81.8904,
    width: 12.9811,
    height: 11.5155,
    rx: 1.9586,
    fill: "white",
    fillOpacity: 0.4
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.0114,
    y: 81.8904,
    width: 12.7751,
    height: 11.5155,
    rx: 1.9586,
    fill: "white",
    fillOpacity: 0.4
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52.8167,
    y: 81.8904,
    width: 13.1872,
    height: 11.5155,
    rx: 1.9586,
    fill: "white",
    fillOpacity: 0.4
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 67.0341,
    y: 81.8904,
    width: 12.7751,
    height: 11.5155,
    rx: 1.9586,
    fill: "white",
    fillOpacity: 0.4
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 81,
    y: 82,
    width: 12.9811,
    height: 11.5155,
    rx: 1.9586,
    fill: "white",
    fillOpacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2587 85.7497V90.023H31.3552V86.6073H31.3302L30.3516 87.2208V86.4195L31.4095 85.7497H32.2587Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M87.5041 90.1911C87.2092 90.1911 86.9463 90.1368 86.7154 90.0283C86.4859 89.9198 86.3037 89.7703 86.1687 89.5797C86.0338 89.3891 85.9635 89.1707 85.958 88.9245H86.8343C86.8441 89.09 86.9136 89.2243 87.043 89.3272C87.1724 89.4301 87.3261 89.4816 87.5041 89.4816C87.646 89.4816 87.7712 89.4503 87.8797 89.3877C87.9896 89.3237 88.0752 89.2354 88.1364 89.1227C88.199 89.0087 88.2303 88.8779 88.2303 88.7305C88.2303 88.5802 88.1983 88.4481 88.1343 88.334C88.0717 88.2199 87.9847 88.1309 87.8735 88.0669C87.7622 88.0029 87.6349 87.9702 87.4916 87.9689C87.3664 87.9689 87.2447 87.9946 87.1265 88.0461C87.0096 88.0975 86.9185 88.1678 86.8531 88.2568L86.0498 88.1128L86.2522 85.8593H88.8646V86.598H86.9971L86.8865 87.6684H86.9115C86.9867 87.5627 87.1 87.475 87.2517 87.4055C87.4033 87.3359 87.573 87.3011 87.7608 87.3011C88.0181 87.3011 88.2476 87.3617 88.4493 87.4827C88.6511 87.6037 88.8103 87.7699 88.9272 87.9814C89.044 88.1914 89.1018 88.4335 89.1004 88.7075C89.1018 88.9954 89.035 89.2514 88.9 89.4754C88.7665 89.6979 88.5794 89.8732 88.3388 90.0012C88.0995 90.1278 87.8213 90.1911 87.5041 90.1911Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M71.7166 89.3276V88.616L73.5006 85.8054H74.114V86.7903H73.751L72.6263 88.5701V88.6035H75.1615V89.3276H71.7166ZM73.7677 90.0787V89.1105L73.7844 88.7955V85.8054H74.6315V90.0787H73.7677Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3996 90.0815C59.088 90.0815 58.8105 90.0279 58.567 89.9208C58.325 89.8123 58.1337 89.6635 57.9932 89.4743C57.8541 89.2837 57.7825 89.0639 57.7783 88.8149H58.6881C58.6936 88.9193 58.7277 89.0111 58.7903 89.0903C58.8543 89.1682 58.9391 89.2288 59.0449 89.2719C59.1506 89.315 59.2695 89.3366 59.4017 89.3366C59.5394 89.3366 59.6611 89.3122 59.7668 89.2635C59.8725 89.2148 59.9553 89.1474 60.0151 89.0611C60.0749 88.9749 60.1048 88.8754 60.1048 88.7628C60.1048 88.6487 60.0728 88.5478 60.0089 88.4602C59.9463 88.3712 59.8558 88.3016 59.7376 88.2515C59.6208 88.2015 59.4817 88.1764 59.3203 88.1764H58.9218V87.5129H59.3203C59.4566 87.5129 59.5769 87.4893 59.6813 87.442C59.787 87.3947 59.8691 87.3293 59.9275 87.2458C59.9859 87.161 60.0151 87.0622 60.0151 86.9495C60.0151 86.8424 59.9894 86.7485 59.9379 86.6678C59.8878 86.5858 59.8169 86.5218 59.7251 86.4759C59.6347 86.43 59.5289 86.407 59.4079 86.407C59.2855 86.407 59.1735 86.4293 59.072 86.4738C58.9704 86.5169 58.8891 86.5788 58.8279 86.6595C58.7667 86.7402 58.734 86.8348 58.7298 86.9433H57.8639C57.868 86.697 57.9383 86.48 58.0746 86.2923C58.2109 86.1045 58.3945 85.9577 58.6255 85.852C58.8578 85.7449 59.12 85.6913 59.4121 85.6913C59.707 85.6913 59.965 85.7449 60.1862 85.852C60.4074 85.9591 60.5792 86.1038 60.7016 86.286C60.8254 86.4668 60.8866 86.6699 60.8852 86.8953C60.8866 87.1345 60.8122 87.3341 60.662 87.4941C60.5131 87.6541 60.3191 87.7556 60.0798 87.7988V87.8321C60.3942 87.8725 60.6334 87.9817 60.7976 88.1597C60.9631 88.3364 61.0452 88.5576 61.0438 88.8233C61.0452 89.0667 60.9749 89.283 60.8331 89.4722C60.6926 89.6614 60.4985 89.8102 60.2509 89.9187C60.0033 90.0272 59.7195 90.0815 59.3996 90.0815Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8947 90.023V89.372L45.4159 87.9636C45.5452 87.8384 45.6537 87.7257 45.7414 87.6256C45.8304 87.5254 45.8979 87.4274 45.9438 87.3314C45.9897 87.234 46.0126 87.129 46.0126 87.0163C46.0126 86.8911 45.9841 86.7833 45.9271 86.6929C45.87 86.6011 45.7921 86.5308 45.6934 86.4821C45.5946 86.4321 45.4826 86.407 45.3574 86.407C45.2267 86.407 45.1126 86.4334 45.0152 86.4863C44.9179 86.5392 44.8427 86.615 44.7899 86.7137C44.737 86.8125 44.7106 86.93 44.7106 87.0664H43.853C43.853 86.7868 43.9163 86.544 44.0429 86.3382C44.1695 86.1323 44.3468 85.973 44.575 85.8603C44.8031 85.7477 45.066 85.6913 45.3637 85.6913C45.6697 85.6913 45.9361 85.7456 46.1629 85.8541C46.391 85.9612 46.5683 86.11 46.6949 86.3006C46.8215 86.4912 46.8848 86.7096 46.8848 86.9558C46.8848 87.1171 46.8528 87.2764 46.7888 87.4336C46.7262 87.5908 46.6143 87.7654 46.4529 87.9573C46.2915 88.1479 46.0641 88.3767 45.7706 88.6438L45.1467 89.2552V89.2844H46.9411V90.023H43.8947Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.dc938e1b569de93bb43cde8cc1d64319.svg";
export { ForwardRef as ReactComponent };